import {
  FormConfigurationProps,
  FormsPage,
} from '~/components/forms/FormsPage';
import { NoAccessContactCTA } from '~/components/forms/NoAccessContactCTA';
import { useEntitlements } from '~/hooks/account';

const Forms = ({
  integration,
  selectedTab = 'configuration',
}: FormConfigurationProps) => {
  const { hasAccessFormsHubspotEditing } = useEntitlements();

  return hasAccessFormsHubspotEditing ? (
    <FormsPage integration={integration} selectedTab={selectedTab} />
  ) : (
    <NoAccessContactCTA />
  );
};

export default Forms;
